import { createReducer } from 'service/utility';
import { appActions } from '../actions';


const initialState = null;

export default createReducer(initialState, {
  [appActions.SET_ACCESS_TOKEN]: (state, { accessToken }) => accessToken,
  [appActions.REMOVE_ACCESS_TOKEN]: (state) => initialState,
});
